import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Target = () => {
    return (
        <div className="pochtabank-target">
            <FullWrapper>
                <div className="pochtabank-targetWrapper">
                    <div className="pochtabank-targetLeft">Цель</div>
                    <div className="pochtabank-targetRight">
                        Перенести сайт крупного банка на&nbsp;новую платформу и&nbsp;повысить его
                        отказоустойчивость
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Target;
